import type { MessageKey } from './en';

export const om: Partial<Record<MessageKey, string>> = {
  'app.name': 'Edil',
  'app.tagline': 'Lootarii yeroo murtaa’e',
  'nav.lobby': 'Kutaalee',
  'nav.raffle': 'Lootarii',
  'nav.bingo': 'Biingoo',
  'nav.tickets': 'Tikeetii koo',
  'nav.wallet': 'Waaleetii',
  'nav.profile': 'Piroofaayilii',
  'nav.main': 'Ijoo',
  'nav.account': 'Baafata herregaa',
  'nav.section.play': 'Taphadhu',
  'nav.section.money': 'Maallaqa',
  'nav.section.account': 'Herrega',
  'common.loading': 'Fe’aa jira…',
  'common.retry': 'Irra deebi’ii yaali',
  'common.cancel': 'Haqi',
  'common.confirm': 'Mirkaneessi',
  'common.save': 'Olkaa’i',
  'common.close': 'Cufi',
  'common.back': 'Duubatti',
  'common.offline': 'Interneetii irraa addaan citeetta. Odeeffannoo dhumaa qabnu agarsiisaa jirra.',
  'common.live_paused': 'Haaromsi kallattii dhaabateera; sekondii 5 hunda haaromsaa jira.',
  'common.error_title': 'Wanti tokko dogoggora',
  'common.offline_title': 'Interneetii irraa addaan citeetta',
  'common.not_found': 'Fuulli hin argamne',
  'status.live': 'Kallattiin',
  'status.reconnecting': 'Irra deebi’ee walqabsiisaa jira',
  'auth.sign_in': 'Seeni',
  'auth.sign_out': 'Ba’i',
  'auth.register': 'Herrega uumi',
  'auth.phone': 'Lakkoofsa bilbilaa',
  'auth.password': 'Jecha icciitii',
  'auth.display_name': 'Maqaa kee',
  'auth.dob': 'Guyyaa dhalootaa',
  'auth.confirm_age': 'Umuriin koo yoo xiqqaate {age} dha',
  'auth.accept_terms': 'Haalawwanii fi seera taphataa itti gaafatamummaa qabuu nan fudhadha',
  'auth.no_account': 'Edil irratti haaraa dha?',
  'auth.have_account': 'Duraan herrega qabdaa?',
  'auth.with_telegram': 'Telegram’n itti fufi',
  'auth.forgot': 'Jecha icciitii irraanfattee?',
  'auth.reset_sent': 'Lakkoofsi kun herrega Telegram walqabate yoo qabaate, liinkii haaromsaa achitti ergineerra.',
  'auth.reset_title': 'Jecha icciitii haaraa filadhu',
  'auth.reset_done': 'Jechi icciitii jijjiirameera. Maaloo seeni.',
  'auth.new_password': 'Jecha icciitii haaraa',
  'auth.sign_in_to_play': 'Tikeetii bitachuuf seeni',
  'auth.invite_code': 'Koodii afeerraa (dirqama miti)',
  'auth.link_existing': 'Marsariitii irraa herrega Edil qabdaa? Kanaa mannaa seeni, herregni Telegram kun isa wajjin walqabata.',
  'auth.invite_hint': 'Hiriyaa ykn liinkii si afeere irraa.',
  'auth.telegram_sub': 'Herrega Telegram keetiin seenta. Jechi icciitii hin barbaachisu.',
  'auth.use_password': 'Kanaa mannaa lakkoofsa bilbilaa fi jecha icciitii fayyadami',
  'auth.telegram_failed': 'Telegram’n seenuun hin hojjenne. Edil cufii bootii irraa irra deebi’ii bani, ykn yeroo muraasa booda yaali.',
  'auth.telegram_hint_web': 'Telegram keessatti galmoofteettaa? Qabduu Telegram olii fayyadami, ykn jecha icciitii Telegram keetti ergamuuf “Jecha icciitii irraanfattee?” tuqi.',
  'auth.welcome_back': 'Baga deebitee dhufte',
  'auth.sign_in_sub': 'Taphachuuf lakkoofsa bilbila keetiin seeni.',
  'auth.back_to_sign_in': 'Gara seensaatti deebi’i',
  'auth.reset_request_title': 'Jecha icciitii kee haaromsi',
  'auth.reset_request_sub': 'Liinkii haaromsaa herrega Telegram lakkoofsa kee wajjin walqabatetti ni ergina.',
  'auth.send_reset': 'Liinkii haaromsaa ergi',
  'auth.or': 'ykn',
  'auth.browse_rooms': 'Kutaalee ilaali',
  'auth.create_title': 'Herrega kee uumi',
  'auth.create_sub': 'Daqiiqaa tokko fudhata. Taphachuuf umuriin kee 21 ykn isaa ol ta’uu qaba.',
  'auth.finish_title': 'Galmee xumuri',
  'auth.finish_sub': 'Taphachuu jalqabuuf lakkoofsa bilbilaa fi guyyaa dhalootaa kee dabali.',
  'auth.dob_hint': 'Umuriin kee yoo xiqqaate {age} ta’uu qaba.',
  'auth.password_hint': 'Yoo xiqqaate qubee 8. Jecha icciitii beekamaa irraa fagaadhu.',
  'auth.reset_sub': 'Jecha icciitii kanaan dura itti hin fayyadamne filadhu.',
  'auth.save_password': 'Jecha icciitii olkaa’i',
  'auth.sign_in_required': 'Itti fufuuf seeni',
  'auth.sign_in_required_hint': 'Tikeetiin, waaleetiin fi piroofaayiliin kee erga seentee booda ni argamu.',
  'auth.brand_headline': 'Baasii haqa qabeessa. Badhaasa dhugaa. Daqiiqaa muraasa hunda.',
  'auth.brand_lead': 'Kutaatti makami, lakkoofsota kee filadhuu baasii carraa kallattiin daawwadhu.',
  'auth.point_fair': 'Haqummaan isaa mirkanaa’aa',
  'auth.point_fair_text': 'Baasiin hundi dursee waadaa itti seenameera, namni kamiyyuu mirkaneessuu danda’a.',
  'auth.point_live': 'Bu’aa kallattii',
  'auth.point_live_text': 'Baasii akkuma ta’uun daawwadhu; badhaasni battaluma waaleetii keetti gala.',
  'auth.point_payout': 'Kaffaltii Telebirr',
  'auth.point_payout_text': 'Mo’icha kee lakkoofsa Telebirr keetti baafadhu.',
  'lobby.title': 'Kutaalee',
  'lobby.draw_in': 'Baasiin carraa',
  'lobby.sold': '{board} keessaa {sold} gurgurameera',
  'lobby.first_prize': 'Badhaasa 1ffaa',
  'lobby.your_tickets': '{count} kan kee',
  'lobby.no_round': 'Marsaan itti aanu dhiyootti banama',
  'lobby.winners': 'Mo’attoota dhihoo',
  'lobby.winner_line': '{name} {room} keessatti {amount} mo’ateera',
  'lobby.eyebrow': 'Lootarii yeroo murtaa’e',
  'lobby.description': 'Kutaa filadhu, lakkoofsota kee filadhuu baasii carraa kallattiin daawwadhu.',
  'lobby.next_draw': 'Baasii itti aanu · {room}',
  'lobby.live_pools': 'Badhaasa kallattii',
  'lobby.my_active': 'Tikeetii kee hojii irra jiran',
  'lobby.rooms': 'Kutaalee',
  'lobby.per_ticket': 'tikeetii tokkoof',
  'lobby.board_of': 'Lakkoofsota 1–{size}',
  'lobby.sold_short': 'gurgurame',
  'lobby.min': 'Xiqqaate {min}',
  'lobby.always_draws': 'Yeroo hunda ni baafama',
  'lobby.play': 'Taphadhu',
  'lobby.winners_sub': 'Baasiiwwan dhihoo xumuraman',
  'lobby.no_winners': 'Ammaaf mo’ataan hin jiru',
  'lobby.up_to': 'Hanga {amount}',
  'lobby.potential_hint': 'Lakkoofsi hundi yoo gurgurame',
  'room.pick': 'Lakkoofsota kee filadhu',
  'room.lucky_dip': 'Carraadhaan filadhu',
  'room.basket': 'Filannoo kee',
  'room.clear': 'Haqi',
  'room.buy': 'Tikeetii {count} bitadhu',
  'room.confirm_title': 'Bittaa mirkaneessi',
  'room.total': 'Waliigala',
  'room.balance_after': 'Haftee booda',
  'room.bought': 'Carraa gaarii! Tikeetii haaraa {count} qabda.',
  'room.cap': 'Taphataa tokkoof hanga tikeetii {max}',
  'room.taken': 'Fudhatameera',
  'room.mine': 'Kan kee',
  'room.sales_closed': 'Gurgurtaan cufameera. Baasiin carraa dhiyoo…',
  'room.prizes': 'Badhaasa amma',
  'room.chance': 'Carraa tikeetiin tokko badhaasa itti argatu: {pct}',
  'room.min_note': 'Baasii carraaf tikeetii {min} barbaada, yoo kana hin taane tikeetiin hundi ni deebi’a.',
  'room.house': 'Edil House',
  'room.house_fill_note': 'Marsaan kun namni muraasni yoo taphate illee ni baafama: tikeetiin {fill} erga gurguramee booda, Edil House hanga {min}tti kan hafe bita.',
  'room.house_fill_rule': 'Taphattoonni yoo xiqqaate {fill} garuu {min} gadi bitan, Edil House tikeetii hafe bitee baasiin carraa yeroo hunda ni ta’a. Tikeetiin House boordii irratti mallattoo qaba, waan mo’atanis gara House deebi’a. Carraan kee tikeetii tokkoof akkuma kutaa guutuu ti.',
  'room.house_fill_rule_named': "Taphattoonni yoo xiqqaate {fill} garuu tikeetii {min} gadi yoo bitan, Edil House tikeetota hafan ni bita. Tikeetonni House asitti akka kan taphattoota biroo mul'atu; fuulli mirkaneessaa isaan tarreessa, wanti isaan mo'atan House'tti deebi'a.",
  'room.rules': 'Seerota',
  'room.history': 'Marsaalee darban',
  'room.add_money': 'Hafteen gahaa miti. Maallaqa galchi',
  'room.board': 'Boordii lakkoofsaa',
  'room.selected': 'Filatame',
  'room.your_ticket': 'Tikeetii kee',
  'room.cap_left': 'Marsaa kana keessatti tikeetii {max} keessaa {left} siif hafeera',
  'room.pick_hint': 'Dabaluuf lakkoofsota boordii irra jiran tuqi.',
  'room.pick_short': 'Lakkoofsa filadhu',
  'room.selected_count': '{count} filatame',
  'room.remove': '#{n} haqi',
  'room.lucky_dip_hint': 'Lakkoofsota bilisaa siif filanna',
  'room.lucky_dip_buy': 'Carraadhaan filadhu × {count}',
  'room.lucky_dip_count': 'Carraadhaan filadhu × {count}',
  'room.balance_after_short': 'Haftee booda: {amount}',
  'room.pay': '{amount} kaffali',
  'room.tickets': 'Tikeetii',
  'room.price_each': 'Gatii tikeetii tokkoo',
  'room.insufficient': 'Hafteen kee bittaa kanaaf gahaa miti.',
  'room.next_round': 'Marsaa itti aanu',
  'room.opens_at': 'Marsaan kun {when} tikeetiif banama. Yeroo sana lakkoofsa filachuu dandeessa.',
  'room.no_round': 'Yeroo ammaa kutaa kana keessatti marsaan banaa hin jiru. Kan itti aanu akkuma qindaa’een asitti mul’ata.',
  'room.drawing_at': 'Baasiin carraa',
  'room.history_sub': 'Marsaalee dhihoo kutaa kanaa',
  'room.schedule': 'Sagantaa',
  'room.board_size': 'Lakkoofsota',
  'room.minimum': 'Tikeetii xiqqaa',
  'room.per_player': 'Tikeetii taphataa tokkoof',
  'room.split': 'Qoodinsa badhaasaa (1ffaa · 2ffaa · 3ffaa)',
  'room.prizes_grow': 'Badhaasni tikeetii gurgurame hundaan guddata.',
  'room.buy_none': 'Tikeetii bitadhu',
  'room.pages': 'Lakkoofsota',
  'round.state.SCHEDULED': 'Dhiyootti banama',
  'round.state.OPEN': 'Banaa',
  'round.state.CLOSED': 'Gurgurtaan cufame',
  'round.state.REFUNDING': 'Deebisaa jira',
  'round.state.REFUNDED': 'Deebi’eera',
  'round.state.RESTARTED': 'Haaraan jalqabe',
  'round.state.DRAWING': 'Baasaa jira',
  'round.state.DRAWN': 'Baafameera',
  'round.state.SETTLING': 'Mo’attootaaf kaffalaa jira',
  'round.state.SETTLED': 'Xumurameera',
  'round.drawing': 'Mo’attoota baasaa jira…',
  'round.results': 'Bu’aa',
  'round.place': 'Sadarkaa {place}',
  'round.you_won': '{amount} mo’atteetta!',
  'round.refunded_note': 'Tikeetiin gahaan waan hin gurguramneef, tikeetiin hundi deebi’eera.',
  'round.restarted_note': 'Marsaa kana keessatti tikeetiin hin gurguramne, kanaaf marsaan haaraan jalqabeera.',
  'round.verify': 'Baasii kana mirkaneessi',
  'round.drawing_sub': 'Bu’aan osoo gurgurtaan hin banamin murtaa’e, mirkaneessuunis ni danda’ama.',
  'round.private_winner': 'Taphataa dhuunfaa',
  'round.winners': 'Mo’attoota',
  'round.fairness': 'Haqummaa',
  'round.fairness_sub': 'Waadaan osoo tikeetiin jalqabaa hin gurguramin maxxanfame',
  'round.pool': 'Badhaasa waliigalaa',
  'round.your_numbers': 'Lakkoofsota kee: {numbers}',
  'verify.title': 'Marsaa kana mirkaneessi',
  'verify.intro': 'Fuulli kun baasii carraa biraawuzara kee keessatti irra deebi’ee mirkaneessa. Sarvara hin amanu.',
  'verify.house_numbers': 'Tikeetota Edil House (guutuu House): {numbers}',
  'verify.commit': 'Sanyiin ifa ba’e waadaa gurgurtaan osoo hin banamin maxxanfame wajjin wal sima',
  'verify.tickets': 'Lakkoofsonni gurguraman galmee yeroo gurgurtaan cufamu fudhatame wajjin wal simu',
  'verify.winners': 'Baasii irra deebi’anii hojjechuun mo’attoota wal fakkaatan kenna',
  'verify.ok': 'Mirkanaa’eera: baasiin kun haqa qabeessa ture.',
  'verify.failed': 'Mirkaneessuun hin milkoofne. Maaloo deeggarsa qunnamaa.',
  'verify.pending': 'Sanyiin baasii carraa booda ifa ba’a. Yeroo sanatti deebi’i.',
  'verify.eyebrow': 'Haqummaan isaa mirkanaa’aa',
  'verify.checks': 'Qorannoo walabaa',
  'verify.raw': 'Odeeffannoo maxxanfame',
  'verify.pending_short': 'Baasii booda ifa ba’a',
  'tickets.title': 'Tikeetii koo',
  'tickets.empty': 'Ammaaf tikeetiin hin jiru.',
  'tickets.status.ACTIVE': 'Baasii eegaa jira',
  'tickets.status.WON': 'Mo’ateera',
  'tickets.status.LOST': 'Hin moone',
  'tickets.status.REFUNDED': 'Deebi’eera',
  'tickets.description': 'Tikeetii qabdu hunda, kan darbee fi kan ammaa.',
  'tickets.filter': 'Tikeetii calleessi',
  'tickets.all': 'Hunda',
  'tickets.draw': 'Baasii',
  'tickets.empty_hint': 'Kutaa kamiyyuu keessatti tikeetii bitadhu, asitti mul’ata.',
  'tickets.browse': 'Kutaalee ilaali',
  'wallet.title': 'Waaleetii',
  'wallet.available': 'Kan jiru',
  'wallet.held': 'Qabamee jira',
  'wallet.history': 'Seenaa',
  'wallet.export': 'CSV buufadhu',
  'wallet.add_money': 'Maallaqa galchi',
  'wallet.free_points': "Edil Coin bilisaa har’aa argadhu",
  'wallet.free_points_done': "Edil Coin bilisaa dabalameera.",
  'wallet.points': "Edil Coin",
  'wallet.empty': 'Ammaaf daddabarsi hin jiru.',
  'wallet.type.DEPOSIT': 'Galchii',
  'wallet.type.TICKET_PURCHASE': 'Tikeetii',
  'wallet.type.REFUND': 'Deebii',
  'wallet.type.PRIZE': 'Badhaasa',
  'wallet.type.FREEPLAY_GRANT': "Edil Coin bilisaa",
  'wallet.type.WITHDRAWAL_HOLD': 'Baasii',
  'wallet.type.WITHDRAWAL_PAID': 'Baasiin kaffalameera',
  'wallet.type.WITHDRAWAL_RELEASE': 'Baasiin deebi’eera',
  'wallet.type.ADJUSTMENT': 'Sirreeffama',
  'wallet.type.REFERRAL_BONUS': 'Boonasii afeerraa',
  'wallet.type.SIGNUP_BONUS': 'Boonasii simannaa',
  'wallet.type.DEPOSIT_BONUS': "Boonasii galchii",
  'wallet.type.BONUS_FORFEIT': "Boonasii haqame",
  'bonus.banner': 'Boonasii galchii jira · hanga +{max}',
  'bonus.offer_title': "Boonasii galchii {pct}% hanga {max}",
  'bonus.offer_title_tiers': "Boonasii galchii hanga {max}",
  'bonus.offer_first': "Galchii kee isa jalqabaa {min} ykn isaa ol irratti",
  'bonus.offer_any': "Galchii kee itti aanu {min} ykn isaa ol irratti",
  'bonus.ends_in': "Kan xumuramu",
  'bonus.preview': "+{bonus} boonasii: {total}n taphatta",
  'bonus.below_min': "Boonasii argachuuf yoo xiqqaate {min} galchi",
  'bonus.next_tier': "Boonasii {bonus} argachuuf {more} dabalii galchi",
  'bonus.terms': "Boonasii baasuuf guyyaa {days} keessatti {wager} taphadhu. Dursitee yoo baafte boonasiin ni haqama.",
  'bonus.blocked.BONUS_ACTIVE': "Kana argachuuf boonasii amma qabdu taphadhuu xumuri.",
  'bonus.blocked.PHONE_NOT_VERIFIED': "Boonasii kana argachuuf Piroofaayilii keessatti lakkoofsa bilbilaa kee mirkaneessi.",
  'bonus.on_approval': "Yeroo galchiin kee mirkanaa’u +{bonus} boonasii",
  'bonus.card_title': "Boonasii kee",
  'bonus.progress': "{required} keessaa {wagered} taphatteetta",
  'bonus.expires': "Hanga {when} tti bani",
  'bonus.completed': "Banameera: baasuu dandeessa",
  'bonus.withdraw_warning': "Boonasiin kee {bonus} ammallee cufaa dha (kan hafe {remaining}). Amma yoo baafte ni haqama.",
  'bonus.forfeit_confirm': "Boonasii koo haqiitii baasi",
  'bonus.cta': "Amma galchi",
  'bonus.paid_badge': "+{bonus} boonasii",
  'bonus.limited': "Carraa daangeffame: kan dursee dhufe",
  'bonus.missed.FIRST_DEPOSIT_ONLY': "Boonasiin kun galchii jalqabaa qofaafi; ati dura galchiteetta. Akkuma duraa maallaqa galchuu dandeessa.",
  'bonus.missed.LIMIT_REACHED': "Boonasii kana duraan argatteetta. Akkuma duraa maallaqa galchuu dandeessa.",
  'bonus.missed.SOLD_OUT': "Boonasiin kun dhumeera: bakki hundi qabameera. Akkuma duraa maallaqa galchuu dandeessa.",
  'bonus.missed.BUDGET_SPENT': "Boonasiin kun dhumeera. Akkuma duraa maallaqa galchuu dandeessa.",
  'bonus.missed.ENDED': "Yeroon boonasii kanaa darbeera. Akkuma duraa maallaqa galchuu dandeessa.",
  'bonus.missed.BONUS_ACTIVE': "Kana argachuuf boonasii amma qabdu taphadhuu xumuri.",
  'bonus.missed.PHONE_NOT_VERIFIED': "Boonasii kana argachuuf Piroofaayilii keessatti lakkoofsa bilbilaa kee mirkaneessi.",
  'bonus.celebrate_title': "🎉 Boonasii {pct}% argachaa jirta!",
  'bonus.celebrate_title_plain': "🎉 Boonasii argachaa jirta!",
  'bonus.celebrate_sub': "Yeroo galchiin kee mirkanaa’u ni dabalama: {total}n taphatta",
  'bonus.added_toast': "🎉 Boonasiin {bonus} waaleetii keetti dabalameera!",
  'wallet.description': 'Haftee keetii fi sochii maallaqaa hunda.',
  'wallet.main': 'Haftee ijoo',
  'wallet.withdraw': 'Baasi',
  'wallet.history_sub': 'Kan dhihoo dursa',
  'invite.title': 'Hiriyoota afeeri',
  'invite.text': 'Liinkii kee qoodi. Badhaasni yeroo hiriyaan kee makamee haala dhiyaate guutu kaffalama.',
  'invite.code': 'Koodii afeerraa kee',
  'invite.copy': 'Liinkii garagalchi',
  'invite.copied': 'Liinkiin garagalfameera.',
  'invite.share': 'Qoodi',
  'invite.share_telegram': 'Telegram irratti qoodi',
  'invite.share_text': 'Edil irratti na wajjin taphadhu: lootarii yeroo murtaa’e kan baasii isaa mirkaneessuu dandeessu. 21+ qofa.',
  'invite.offer': 'Ati {mine} argatta. Hiriyaan kee {theirs} argata. Kan kaffalamu {when}.',
  'invite.when_signup': 'yeroo hiriyaan kee galmaa’u',
  'invite.when_deposit': 'erga hiriyaan kee guyyaa {days} keessatti {amount} galchee booda',
  'invite.when_stake': 'erga hiriyaan kee guyyaa {days} keessatti {amount} taphatee booda',
  'invite.when_verified': ' fi lakkoofsa bilbilaa isaa mirkaneesse',
  'invite.reward_none': 'homaa',
  'invite.reward_points': "Edil Coin {n}",
  'invite.reward_tickets': 'tikeetii bilisaa {amount}',
  'invite.reward_cash': 'maallaqa boonasii {amount}',
  'invite.cash_note': 'Maallaqni boonasii osoo hin baafamin dura al tokko taphatamuu qaba.',
  'invite.no_offer': 'Yeroo ammaa badhaasni hin jiru, garuu liinkiin kee afeerraa kee lakkaa’aa jira.',
  'invite.joined': 'Hiriyoota makaman',
  'invite.pending': 'Eegaa jira',
  'invite.rewarded': 'Badhaafameera',
  'invite.earned': 'Kan argatte',
  'invite.earned_value': "{cash} fi Edil Coin {points}",
  'profile.title': 'Piroofaayilii',
  'profile.language': 'Afaan',
  'profile.theme': 'Bifa',
  'profile.theme_dark': 'Dukkana',
  'profile.theme_light': 'Ifaa',
  'profile.theme_system': 'Akka bilbila koo',
  'profile.support': "Gargaarsa fi deeggarsa",
  'profile.support_text': "Gaaffii qabdaa, ykn rakkoon galchii, baasii ykn taphaa isin mudateeraa? Gareen keenya Telegram irratti deebisa.",
  'profile.support_button': "{handle} barreessi",
  'profile.feed_opt_out': 'Maqaa koo tarree mo’attootaa keessaa dhoksi',
  'profile.pin': 'PIN',
  'profile.pin_set': 'PIN qindaa’eera',
  'profile.pin_new': 'PIN haaraa (lakkoofsa 4–6)',
  'profile.pin_current': 'PIN ammaa',
  'profile.payout': 'Herrega kaffaltii',
  'profile.payout_name': 'Maqaa herrega Telebirr irra jiru',
  'profile.payout_cooldown': 'Baasiin {when} irra deebi’ee jalqaba.',
  'profile.devices': 'Meeshaalee seenan',
  'profile.this_device': 'Meeshaa kana',
  'profile.sign_out_device': 'Ba’i',
  'profile.phone_unverified': 'Lakkoofsa kee mirkaneessuuf, Telegram irratti bootii Edil wajjin quunnamtii kee qoodi.',
  'profile.saved': 'Olkaa’ameera.',
  'profile.link_first': 'Lakkoofsa kee mirkaneessuuf, jalqaba herrega Telegram kee Edil wajjin walqabsiisi.',
  'profile.link_this_telegram': 'Herrega Telegram kana walqabsiisi',
  'profile.telegram_linked_done': 'Telegram walqabateera. Amma bootii Edil keessatti lakkoofsa kee mirkaneessi.',
  'profile.verify_in_bot': 'Telegram kee walqabateera. {phone} mirkaneessuuf bootii Edil bani, /start ergiitii “Lakkoofsa bilbilaa qoodi” tuqi.',
  'profile.open_bot': 'Bootii Edil bani',
  'profile.promotions': 'Beeksisaa fi kennaa Edil naaf ergi',
  'profile.password_set_title': 'Jecha icciitii qindeessi',
  'profile.password_set_text': 'Telegram keessatti ofumaan seenta. edilgames.app irratti lakkoofsa bilbila keetiin seenuuf jecha icciitii qindeessi.',
  'profile.password_change_title': 'Jecha icciitii',
  'profile.password_change_text': 'edilgames.app irratti lakkoofsa bilbila keetiin seenuuf. Jijjiiruun meeshaalee kee kaan keessaa si baasa.',
  'profile.password_current': 'Jecha icciitii ammaa',
  'profile.description': 'Herrega kee, nageenyaa fi filannoo kee.',
  'profile.account': 'Herrega',
  'profile.account_text': 'Taphattoonni biroo akkamitti si argan.',
  'profile.verified': 'Mirkanaa’eera',
  'profile.unverified': 'Hin mirkanoofne',
  'profile.preferences': 'Filannoo',
  'profile.preferences_text': 'Afaanii fi dhuunfummaa.',
  'profile.pin_text': 'Baasii fi lakkoofsa kaffaltii jijjiiruuf barbaachisa.',
  'profile.pin_create': 'PIN qindeessi',
  'profile.pin_change': 'PIN jijjiiri',
  'profile.payout_text': 'Baasiin lakkoofsa Telebirr ykn herrega baankii olkaa’atte qofatti ergama. Yeroo hunda isa kam akka ta’e ati filatta.',
  'profile.payout_save': 'Olkaa’i',
  'profile.payout_edit': 'Jijjiiri',
  'profile.payout_remove': 'Haqi',
  'profile.payout_bank': 'Herrega baankii',
  'profile.payout_bank_badge': 'Baankii',
  'profile.payout_bank_pick': 'Baankii',
  'profile.payout_bank_choose': 'Baankii kee filadhu',
  'profile.payout_account_number': 'Lakkoofsa herregaa',
  'profile.payout_bank_name': 'Maqaa herrega baankii irra jiru',
  'profile.devices_text': 'Meeshaalee itti hin fayyadamne keessaa ba’i.',
  'profile.active_now': 'Amma hojii irra jira',
  'phone_verify.title': 'Bilbila kee mirkaneessi',
  'phone_verify.cta': 'Amma mirkaneessi',
  'phone_verify.later': 'Booda',
  'phone.share_title': 'Lakkoofsa bilbila kee qoodi',
  'phone.share_body': 'Edil lakkoofsa herrega Telegram kee irra jiru fayyadama, kanaaf battaluma mirkanaa’a. Tuqaa tokko qofa.',
  'phone.share_button': 'Lakkoofsa bilbilaa qoodi',
  'phone.waiting': 'Telegram eegaa jira…',
  'phone.shared': 'Lakkoofsi bilbilaa Telegram irraa dabalameera',
  'phone.declined': 'Asitti galmaa’uuf lakkoofsa bilbila kee qooduu qabda.',
  'phone.timeout': 'Telegram ammaaf hin erganne. Yeroo muraasa booda qabduu irra deebi’ii tuqi.',
  'phone.unsupported': 'Lakkoofsa bilbila kee qooduuf Telegram haaromsi, ykn bootii Edil banii “Lakkoofsa bilbilaa qoodi” tuqi.',
  'phone.gate': 'Tikeetii bitachuu fi maallaqa galchuuf lakkoofsa bilbila kee qoodi. Baasii irratti dhiibbaa hin qabu.',
  'phone.verified': 'Galatoomi, lakkoofsi bilbila kee mirkanaa’eera.',
  'gift.eyebrow': 'Kennaa',
  'gift.reward': 'Kennaa tokkoon tokkoon',
  'gift.claim': 'Kennaa koo argadhu',
  'gift.won_title': 'Kan kee ti!',
  'gift.won_body': "Edil Coin {points} herrega keetti dabalameera. Tikeetii bilisaaf itti fayyadami.",
  'gift.play': 'Amma taphadhu',
  'gift.starts_in': '{time} keessatti banama. Fuula kana irra turi: ofumaan banama.',
  'gift.sold_out': 'Kennaan hundi fudhatameera. Kennaa itti aanuuf bootii fi garee hordofi!',
  'gift.closed': 'Yeroon isaa darbeera',
  'gift.join_to_claim': 'Fudhachuuf Edil’tti makami',
  'gift.verified_only': 'Taphattoota lakkoofsa bilbilaa mirkanaa’e qabaniif.',
  'gift.not_found': 'Liinkiin kennaa kun sirrii miti.',
  'share.win_button': 'Mo’icha koo qoodi',
  'share.win_text': '🎉 Amma Edil irratti {amount} mo’adheera! Liinkii kootiin makamii ati illee carraa kee yaali (21+):',
  'share.failed': 'Qooduun hin banamne. Maaloo irra deebi’ii yaali.',
  'tgsignup.welcome': 'Baga nagaan dhufte, {name}!',
  'tgsignup.sub': 'Tuqaa tokkoon seenta. Edil lakkoofsa bilbilaa herrega Telegram kee irra jiru fayyadama, kanaaf battaluma mirkanaa’a.',
  'tgsignup.confirm': 'Umuriin koo yoo xiqqaate {age} dha, haalawwanii fi seera taphataa itti gaafatamummaa qabuu nan fudhadha',
  'tgsignup.share_join': 'Bilbila qoodiitii makami',
  'tgsignup.join': 'Edil’tti makami',
  'tgsignup.phone_ready': 'Lakkoofsa bilbilaa Telegram irraa: {phone}',
  'tgsignup.invited': 'Koodii {code}n afeeramte',
  'tgsignup.have_code': 'Koodii afeerraa qabdaa?',
  'tgsignup.use_bot': 'Kanaa mannaa chaatii bootii keessatti qoodi',
  'tgsignup.bot_hint': 'Chaatii bootii keessatti “Lakkoofsa bilbilaa qoodi” tuqiitii asitti deebi’i. Galmeen ofumaan xumurama.',
  'rg.footer': 'Itti gaafatamummaan taphadhu. 21+ qofa.',
  'rg.title': 'Taphata itti gaafatamummaa qabu',
  'rg.text': 'Daangaa kaa’iitii boqonnaa fudhadhu. Daangaa gadi buusuun battaluma hojjeta; ol kaasuun ykn haquun sa’aatii 24 fi PIN kee barbaada.',
  'rg.limits': 'Daangaa kee',
  'rg.limits_text': 'Hammi ETB’n; yeroon taphaa daqiiqaan. Daangaa malee gochuuf duwwaa dhiisi.',
  'rg.kind.DEPOSIT_DAILY': 'Galchii guyyaatti',
  'rg.kind.DEPOSIT_WEEKLY': 'Galchii torbanitti',
  'rg.kind.DEPOSIT_MONTHLY': 'Galchii ji’aan',
  'rg.kind.LOSS_DAILY': 'Kasaaraa guyyaatti',
  'rg.kind.LOSS_WEEKLY': 'Kasaaraa torbanitti',
  'rg.kind.LOSS_MONTHLY': 'Kasaaraa ji’aan',
  'rg.kind.SPEND_PER_ROUND': 'Baasii marsaa tokkoof',
  'rg.kind.SESSION_MINUTES': 'Yeroo taphaa (daqiiqaa)',
  'rg.no_limit': 'Daangaa hin qabu',
  'rg.pending': '{when} irratti gara {value}tti jijjiirama',
  'rg.set': 'Olkaa’i',
  'rg.raise_title': 'PIN keetiin mirkaneessi',
  'rg.raise_text': 'Daangaa ol kaasuun ykn haquun sa’aatii 24 booda hojii irra oola.',
  'rg.break': 'Boqonnaa fudhadhu',
  'rg.break_text': 'Boqonnaan tikeetii fi galchii karaa hundaan dhorka. Osoo yeroon isaa hin gahin hin dhaabbatu. Haftee kee baafachuu ni dandeessa.',
  'rg.cool_off': 'Boqonnaa gabaabaa',
  'rg.self_exclusion': 'Of dhorkuu',
  'rg.period.24H': 'Sa’aatii 24',
  'rg.period.7D': 'Guyyaa 7',
  'rg.period.30D': 'Guyyaa 30',
  'rg.period.6M': 'Ji’a 6',
  'rg.period.1Y': 'Waggaa 1',
  'rg.period.PERMANENT': 'Bara baraan',
  'rg.confirm_title': '{period}f {kind} jalqabuu?',
  'rg.confirm_text': 'Hanga inni xumuramutti tikeetii bitachuu ykn maallaqa galchuu hin dandeessu, haquunis hin danda’amu.',
  'rg.confirm_check': 'Kun osoo yeroon isaa hin gahin akka hin haqamne nan hubadha',
  'rg.start': 'Boqonnaa jalqabi',
  'rg.active': '{kind} kee hanga {until}tti hojii irra jira. Tikeetii fi galchiin dhorkamaniiru; baasiin ni danda’ama.',
  'rg.active_permanent': 'Bara baraan of dhorkiteetta. Tikeetii fi galchiin dhorkamaniiru; baasiin ni danda’ama.',
  'rg.banner': 'Boqonnaa irra jirta. Tikeetii fi galchiin dhorkamaniiru; haftee kee baafachuu ni dandeessa.',
  'rg.reality_title': 'Yeroo of ilaaluu',
  'rg.reality_text': 'Daqiiqaa {minutes} taphatteetta. Yeroo taphaa kana keessatti {staked} taphatteetta; bu’aan kee {net}.',
  'rg.keep_playing': 'Taphachuu itti fufi',
  'loyalty.title': "Edil Coin",
  'loyalty.text': "ETB tokko taphattu hundaaf Edil Coin {rate} argadhu. Edil Coin tikeetii bilisaaf fayyadami; gara maallaqaatti hin jijjiiraman.",
  'loyalty.points': "Edil Coin {points}",
  'loyalty.expiring': "Edil Coin {points} {when} dura yeroon isaa darba",
  'loyalty.pay_points': "Edil Coin {points} fayyadami",
  'loyalty.redeemed': "Tikeetiin bilisaa dabalameera, Edil Coin-iin kaffalameera.",
  'notifications.title': 'Beeksisota',
  'notifications.description': 'Mo’icha, galchii, baasii fi ergaa herregaa.',
  'notifications.empty': 'Ammaaf beeksisni hin jiru.',
  'notifications.read_all': 'Hunda akka dubbifametti mallatteessi',
  'notifications.open': 'Beeksisota',
  'cashier.requests': 'Galchii fi baasii',
  'cashier.requests_sub': 'Gaaffiiwwan adeemsa irra jiranii fi haala isaanii',
  'cashier.deposit_title': 'Telebirr’n maallaqa galchi',
  'cashier.deposit_amount_sub': 'Hamma galchuu barbaaddu galchi. {min} fi {max} gidduu.',
  'cashier.amount': 'Hamma (ETB)',
  'cashier.continue': 'Itti fufi',
  'cashier.pay_title': 'Maallaqa Telebirr keessatti ergi',
  'cashier.pay_sub': 'Hamma kana sirriitti herrega armaan gadiitti ergiitii mirkaneessuuf deebi’i.',
  'cashier.send_to': 'Lakkoofsa Telebirr',
  'cashier.holder': 'Maqaa herregaa',
  'cashier.exact_amount': 'Hamma sirrii',
  'cashier.reference': 'Wabii',
  'cashier.time_left': 'Yeroo hafe',
  'cashier.copied': 'Garagalfameera',
  'cashier.copy': 'Garagalchi',
  'cashier.step1': 'Telebirr banii “Maallaqa ergi” filadhu.',
  'cashier.step2': 'Lakkoofsa olii galchiitii maqaan “{name}” ta’uu isaa mirkaneeffadhu.',
  'cashier.step3': 'Sirriitti {amount} ergi. Telebirr yoo hayyame, iddoo sababaa irratti {reference} barreessi.',
  'cashier.step4': 'SMS mirkaneessaa olkaa’i ykn suuraa nagahee kaasi.',
  'cashier.i_paid': 'Kaffaleera',
  'cashier.proof_title': 'Kaffaltii kee mirkaneessi',
  'cashier.proof_sub': 'Kaffaltii hunda harkaan ni mirkaneessina. Yeroo baay’ee {start}–{end} keessatti daqiiqaa {minutes} keessatti.',
  'cashier.txn_id': 'Lakkoofsa daddabarsa Telebirr',
  'cashier.txn_hint': 'SMS mirkaneessaa irraa, fkn CJK3ABC12D',
  'cashier.sender_number': 'Lakkoofsa irraa kaffalte',
  'cashier.screenshot': 'Suuraa nagahee',
  'cashier.screenshot_hint': 'JPEG ykn PNG, hanga 5 MB',
  'cashier.choose_screenshot': 'Suuraa filachuuf tuqi',
  'cashier.submit_proof': 'Ilaalchaaf ergi',
  'cashier.submitted_title': 'Kaffaltiin ergameera',
  'cashier.submitted_text': 'Akkuma kaffaltiin mirkanaa’een waaleetii keetti ni galchina. Beeksisni siif dhufa.',
  'cashier.done': 'Xumurameera',
  'cashier.continue_request': 'Itti fufi',
  'cashier.withdraw_title': 'Baasi',
  'cashier.withdraw_sub': 'Maallaqni herrega kaffaltii piroofaayilii kee keessatti olkaa’ame qofatti ergama.',
  'cashier.withdraw_to': 'Kan itti kaffalamu',
  'cashier.withdraw_target': 'Yeroo baay’ee {start}–{end} keessatti daqiiqaa {minutes} keessatti kaffalama.',
  'cashier.keep_balance': '{keep} yeroo hunda herrega kee keessa tura.',
  'cashier.deposit_first': 'Injifannoo boonasii baga nagaan dhuftee baasuuf galchii kee isa jalqabaa raawwadhu.',
  'cashier.withdraw_limits': '{min} fi {max} gidduu. Kan jiru: {available}.',
  'cashier.pin': 'PIN',
  'cashier.request_withdrawal': 'Baasii gaafadhu',
  'cashier.withdraw_requested': 'Baasiin gaafatameera. Hammi kun hanga kaffalamutti qabamee tura.',
  'cashier.no_payout': 'Osoo hin baasin dura piroofaayilii kee keessatti lakkoofsa Telebirr ykn herrega baankii dabali.',
  'cashier.no_pin': 'Osoo hin baasin dura piroofaayilii kee keessatti PIN uumi.',
  'cashier.go_profile': 'Piroofaayilii bani',
  'cashier.cooldown': 'Herregni kaffaltii kee dhiyeenya jijjiirameera. {when} irraa eegalee baasuu dandeessa.',
  'cashier.playthrough': 'Osoo hin baasin dura {remaining} dabalataan taphadhu (galchiin al tokko taphatamuu qaba).',
  'cashier.cancel_withdrawal': 'Haqi',
  'cashier.withdrawal_cancelled': 'Baasiin haqameera. Maallaqni waaleetii keetti deebi’eera.',
  'cashier.unavailable': 'Haala kana keessatti galchii fi baasiin hin jiran.',
  'cashier.deposit': 'Galchii',
  'cashier.withdrawal': 'Baasii',
  'cashier.deposit_approved': 'Galchiin kee mirkanaa’eera.',
  'cashier.state.AWAITING_PAYMENT': 'Kaffaltii eegaa jira',
  'cashier.state.SUBMITTED': 'Ilaalamaa jira',
  'cashier.state.NEEDS_INFO': 'Tarkaanfiin barbaachisa',
  'cashier.state.PENDING_SECOND_APPROVAL': 'Ilaalamaa jira',
  'cashier.state.APPROVED': 'Mirkanaa’eera',
  'cashier.state.REJECTED': 'Hin mirkanoofne',
  'cashier.state.EXPIRED': 'Yeroon isaa darbeera',
  'cashier.state.REQUESTED': 'Gaafatameera',
  'cashier.state.PAID': 'Kaffalameera',
  'cashier.state.CANCELLED': 'Haqameera',
  'cashier.state.FAILED': 'Hin milkoofne',
  'cashier.late_ok': 'Duraan kaffalteettaa? Hanga {when}tti ragaa erguu dandeessa.',
  'bingo.title': 'Biingoo Ariifataa',
  'bingo.eyebrow': 'Sagaleedhaan waamama · sarara kamiyyuu ni mo’a',
  'bingo.lobby_sub': 'Hanga kaartellaa 4 filadhuutii kubbaawwan dhaggeeffadhu. Sararri jalqabaa ni mo’a.',
  'bingo.per_cartela': 'kaartellaa tokkoof',
  'bingo.prize': 'Mo’ataan kan argatu',
  'bingo.guaranteed': "Mirkanaa'aa · taphattoonni yommuu dabalan guddata",
  'bingo.guaranteed_from': "Taphattoonni {n} yommuu makaman mirkanaa'a",
  'bingo.prize_grows': 'Kaartellaa gurgurame hundaan guddata',
  'bingo.players': 'Taphattoota {min} keessaa {players}',
  'bingo.players_short': 'taphattoota',
  'bingo.joined': '{players} makamaniiru · kaartellaa {cartelas}',
  'bingo.min_players': 'Taphattoota xiqqaate {min}',
  'bingo.starts_in': 'Kan jalqabu',
  'bingo.waiting': 'Taphattoota eegaa jira',
  'bingo.calling': 'Waamaa jira',
  'bingo.state.OPEN': 'Amma makami',
  'bingo.state.CALLING': 'Taphataa jira',
  'bingo.state.SETTLED': 'Xumurameera',
  'bingo.state.REFUNDING': 'Deebisaa jira',
  'bingo.state.REFUNDED': 'Deebi’eera',
  'bingo.play_now': 'Amma taphadhu',
  'bingo.watch_live': 'Kallattiin daawwadhu',
  'bingo.guaranteed_short': "Badhaasa mirkanaa'e",
  'bingo.balls_short': 'Kubbaa {count}',
  'bingo.cartelas_short': 'Kaartellaa {count}',
  'bingo.round_info': 'Marsaa kana',
  'bingo.pick_now': 'Cufamuuf jira — amma kaartellaa filadhu!',
  'bingo.extended_flash': 'Yeroon dabalameera — taphattoonni ammallee makamaa jiru',
  'bingo.play': 'Makami',
  'bingo.watch': 'Daawwadhu',
  'bingo.pick': 'Kaartellaa kee filadhu',
  'bingo.pick_hint': 'Kaardii isaa arguuf lakkoofsa tuqi. Marsaa tokkoof hanga {max}.',
  'bingo.selected': 'Filatame',
  'bingo.your_cartelas': 'Kaartellaa kee',
  'bingo.no_cartelas': 'Marsaa kana keessatti kaartellaa hin qabdu.',
  'bingo.buy': 'Kaartellaa {count} bitadhu',
  'bingo.buy_none': 'Kaartellaa filadhu',
  'bingo.buy_now': '{count} bitadhu · {amount}',
  'bingo.pick_short': 'Filachuuf lakkoofsa tuqi',
  'bingo.bought': 'Kaartellaan {count} bitameera. Carraa gaarii!',
  'bingo.bought_points': "Kaartellaan {count} dabalameera, Edil Coin-iin kaffalameera.",
  'bingo.points_balance': "Edil Coin {points} qabda. Kaartellaan ETB 10 Edil Coin {cost} baasa.",
  'bingo.points_short': '⭐ {points}',
  'bingo.confirm_title': 'Kaartellaa bitadhu',
  'bingo.cartelas': 'Kaartellaa',
  'bingo.cartela_no': 'Kaartellaa #{n}',
  'bingo.cap_left': 'Marsaa kana {max} keessaa {left} hafeera',
  'bingo.closed': 'Marsaan kun jalqabeera. Marsaan itti aanu yeroo kun xumuramu banama.',
  'bingo.house_fill_note': 'Taphattoota {fill}+ yoo jiraatan, Edil House teessoo duwwaa guutee taphni yeroon jalqaba.',
  'bingo.house_names_note': "Teessoon House maqaa taphataatiin mul'ata; fuulli mirkaneessaa isaan tarreessa.",
  'bingo.house_seats': 'Kaartellaa Edil House',
  'bingo.at_least': 'Yoo xiqqaate',
  'bingo.guaranteed_min': "Xiqqaataan mirkanaa'e · taphattoonni yommuu dabalan guddata",
  'bingo.today_best': "Mo'icha guddaa har'aa: {amount}",
  'bingo.guaranteed_at_close': 'Yeroo cufamu yoo xiqqaate {amount} mirkanaa’eera',
  'bingo.check.house_order': 'Kaartellaan Edil House tartiiba ifaa marsaa sanaa hordofu',
  'bingo.house_order_note': 'Kaartellaa duwwaa tartiiba hash ifaa marsaa sanaatiin murtaa’een fudhata.',
  'bingo.extended': 'Ammaaf taphattoonni gahaan hin jiran: lakkoofsi yeroo dheereffameera ({used}/{max}).',
  'bingo.min_note': 'Taphattoota {min} barbaada. Gahaan yoo hin makamne, kaartellaan hundi ni deebi’a.',
  'bingo.current_ball': 'Kubbaa ammaa',
  'bingo.calls': '75 keessaa {count} waamameera',
  'bingo.called_board': 'Lakkoofsota waamaman',
  'bingo.get_ready': 'Qophaa’i…',
  'bingo.one_to_go': 'Lakkoofsa tokkotu hafe!',
  'bingo.bingo': 'BIINGOO!',
  'bingo.you_won': '{amount} mo’atteetta!',
  'bingo.won_by': 'Kaartellaan #{n} mo’ateera',
  'bingo.winners': 'Mo’attoota',
  'bingo.split': 'Badhaasni mo’attoota {count} gidduutti qoodameera',
  'bingo.house': 'Edil House',
  'bingo.private_winner': 'Taphataa tokko',
  'bingo.next_round': 'Marsaa itti aanu',
  'bingo.refunded': 'Taphattoonni gahaan waan hin makamneef, kaartellaan hundi deebi’eera.',
  'bingo.rules': 'Akkamitti akka hojjetu',
  'bingo.rule_1': 'Osoo lakkoofsi yeroo hin xumuramin hanga kaartellaa {max} filadhu. Tokkoon tokkoon {price} baasa.',
  'bingo.rule_2': 'Sekondii {seconds} hunda kubbaan tokko waamama. Kaardiin kee ofumaan mallattaa’a.',
  'bingo.rule_3': 'Kaardiin jalqaba tarree, utubaa ykn sarara qaxxaamuraa kamiyyuu guute ni mo’a. Yoo wal qixxaatan badhaasni qoodama.',
  'bingo.rule_4': 'Mo’ataan badhaasa waliigalaa keessaa {share}% argata; House {house}% fudhata.',
  'bingo.rule_5': 'Taphattoota {min} barbaada. Marsaaleen gahaa hin taane xiqqoo dabalataan eegu, achiis ni deebisu.',
  'bingo.verify': 'Tapha kana mirkaneessi',
  'bingo.recent': 'Taphoota dhihoo',
  'bingo.pages': 'Lakkoofsota kaartellaa',
  'bingo.go_to': 'Gara kaartellaa #',
  'bingo.go': 'Deemi',
  'bingo.recent_sub': 'Kubbaawwan isaa arguu fi haqa qabeessa ta’uu isaa mirkaneessuuf tapha tuqi.',
  'bingo.history_meta': 'Taphattoota {players} · kubbaa {balls}ffaan mo’ame',
  'bingo.history_meta_one': 'Taphataa 1 · kubbaa {balls}ffaan mo’ame',
  'bingo.verify_title': 'Tapha biingoo mirkaneessi',
  'bingo.verify_sub': 'Tartiibni waamichaa sanyii icciitii irraa dhufa, mallattoon isaa osoo gurgurtaan hin banamin maxxanfameera.',
  'bingo.verify_ok': 'Qorannoon hundi darbeera: taphni kun haqa qabeessa ture.',
  'bingo.verify_bad': 'Qorannoon tokko hin milkoofne. Maaloo deeggarsa qunnamaa.',
  'bingo.check.commit': 'Sanyiin mallattoo maxxanfame wajjin wal sima',
  'bingo.check.tickets': 'Kaartellaan gurguraman hash yeroo cufamu olkaa’ame wajjin wal simu',
  'bingo.check.calls': 'Kubbaawwan waamaman tartiiba sanyichaa hordofu',
  'bingo.check.winners': 'Mo’attoonni sirriitti kaardii jalqaba sarara guutan qofa',
  'bingo.sound_on': 'Sagaleef tuqi',
  'bingo.sound_off': 'Waamaa callisi',
  'bingo.sound_unmute': 'Sagalee waamaa deebisi',
  'bingo.voice': 'Sagalee waamaa',
  'bingo.unavailable': 'Yeroo ammaa Biingoon hin jiru.',
  'bingo.no_round': 'Marsaan itti aanu yeroo muraasa keessatti banama.',
};